import { gql } from '@apollo/client';

export default class PartsSettingsMutation {
static SAVE_DEFAULT_SERVICE_SETTINGS = gql`
  mutation savePartsSettings($input: PartsDefaultSettingsInput!, $lotName: String!) {
    savePartsSettings(input: $input, lotName: $lotName)
  }
`;
}
